import React from 'react'
import PropTypes from 'prop-types'
import { HelpBlock } from 'react-bootstrap'

function Calculator({ title, className = '', children, ...props }) {
  const calculatorClassName = `calculator ${className}`.trim()
  return (
    <div className={calculatorClassName} {...props}>
      <div className="calculator-header">
        <h2 className="emphasized">{title}</h2>
      </div>
      <div className="calculator-main">
        {children}
      </div>
      <div className="calculator-disclaimer">
        <HelpBlock>
          Information and interactive calculators are made available to you as self-help tools for your independent use and are not intended to provide investment advice. We cannot and do not guarantee their applicability or accuracy in regard to your individual circumstances. All examples are hypothetical and are for illustrative purposes. We encourage you to seek personalized advice from qualified professionals regarding all personal finance issues.
        </HelpBlock>
      </div>
    </div>
  )
}

Calculator.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
}

export default Calculator



// WEBPACK FOOTER //
// ./src/components/Calculator/index.js